import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { environment } from "../environments/environment";
import { AgGridModule } from "ag-grid-angular";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { DATE_FORMATS } from "./core/formats/date-formats";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { PendingChangesGuard } from "./core/auth/guards/pending-changes.guard";
import { MatSelectModule } from '@angular/material/select';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';



const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
};

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        MatSelectModule,
        MatSnackBarModule,

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // PDF Viewer
        // PdfJsViewerModule,

        // AG Grid
        AgGridModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),

        //Circle progressbar with defaults
        NgCircleProgressModule.forRoot({
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: "#78C000",
            // innerStrokeColor: "#C7E596",
            animationDuration: 300,

        }),


    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useValue: DATE_FORMATS
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
        PendingChangesGuard,
        provideFirebaseApp(() => initializeApp(environment.config.firebase)),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        { provide: FUSE_CONFIG, useValue: appConfig },
    ],
})
export class AppModule {
}
